const inputs = document.querySelectorAll('#subscription-option');
const submitBtn = document.querySelector('.product-form__submit');
const subscriptionBtns = document.querySelectorAll('.js-open-details');
const descriptions = document.querySelectorAll('.product-form__contents');
const productFormWrappers = document.querySelectorAll('.product-form__input-wrapper');
const productFormTops = document.querySelectorAll('.product-form__top');
let selectedSellingPlanID = null;
let selectedVariantID = null;

// set first input checked and get selectedSellingPlanID and selectedVariantID
if (inputs) {
  inputs.forEach((input) => {
    if (input.checked) {
      selectedSellingPlanID = input.dataset.sellingPlanId;
      selectedVariantID = input.dataset.variantId;
    }
  });
}

subscriptionBtns.forEach((item, index) => {
  const productFormWrapper = item.querySelector('.product-form__input-wrapper');
  const productFormTop = item.querySelector('.product-form__top');
  const input = item.querySelector('#subscription-option');

  // Open the first accordion by default
  if (index === 0) {
    item.classList.add('active');
    accordion({ currentTarget: item });
  }

  // on click of each accordion
  item.addEventListener('click', (e) => {
    // update price
    updatePrice(item);

    // Remove active class from all
    subscriptionBtns.forEach((btn) => {
     btn.classList.remove('active');
    });

    // Remove active class from all
    productFormWrappers.forEach((wrapper) => {
      wrapper.classList.remove('active');
    });

    // set all inputs to unchecked
    inputs.forEach((input) => {
      input.checked = false;
    });

    // Remove active class from all
    productFormTops.forEach((top) => {
      top.classList.remove('active');
    });

    // Add active class to the clicked accordion
    item.classList.add('active');
    if (productFormWrapper) {
      productFormWrapper.classList.add('active');
    }

    if (productFormTop) {
      productFormTop.classList.add('active');
    }
    
    // set input checked of the clicked accordion
    input.checked = true;

    // set selectedSellingPlanID and selectedVariantID
    if (input.checked) {
      selectedSellingPlanID = input.dataset.sellingPlanId;
      selectedVariantID = input.dataset.variantId;
    }

    // call accordion function
    accordion(e);
  });
});

/**
 * Update Price
 */
function updatePrice(item) {
  const productWrapper = document.querySelector('.product__info-wrapper');
  if (!productWrapper) return;

  const productPrice = productWrapper.querySelectorAll('.product__price-wrapper');
  productPrice.forEach((price) => {
    const mainPrice = price.querySelector('.main-price');
    const mainComparePrice = price.querySelector('.old-price');
    const itemPrice = item.querySelector('.product-form__input-price');
    const itemComparePrice = item.querySelector('.product-form__input-price-compare');

    if (mainComparePrice) {
      // update innerHTML of price and compare price
      mainPrice.innerHTML = itemPrice ? itemPrice.innerHTML : '';
      mainComparePrice.innerHTML = itemComparePrice ? itemComparePrice.innerHTML : '';
    } else {
      mainPrice.innerHTML = itemPrice ? itemPrice.innerHTML : '';
    }
  });
}

/**
 * Accordion
 */
function accordion(e) {
  const currentTarget = e.currentTarget;

  descriptions.forEach((desc) => {
    if (desc.style.height && desc.id !== currentTarget.id) {
      // Close other accordions
      desc.style.height = null;
    } else if (currentTarget.id === desc.id) {
      // Open the clicked accordion
      desc.style.height = desc.scrollHeight + 'px';
    }
  });
}

// submit button to add to cart
submitBtn.addEventListener('click', () => {
  submitBtn.setAttribute('disabled', true);
  submitBtn.classList.add('loading');

  addToCart(selectedSellingPlanID, selectedVariantID);
});

/**
 * Add to cart
 */
function addToCart(selectedSellingPlanID, selectedVariantID) {
  const cartDrawer = document.querySelector('cart-drawer');
  const form = document.querySelector('.product_form_id_sub');
  let formData = new FormData(form);
  formData.append('id', selectedVariantID);
  formData.append('quantity', 1);
  if (selectedSellingPlanID) {
    formData.append('selling_plan', selectedSellingPlanID);
  }
  formData.append('sections', getSectionsToRender().map((section) => section.section));

  const results = Object.fromEntries(formData);
  const payLoad = JSON.stringify(results);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: payLoad
  })
  .then((res) => res.json())
  .then((data) => {
    getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = getSectionInnerHTML(data.sections[section.section], section.selector);
    }));
  })
  .catch((err) => console.log(err))
  .finally(() => {
    submitBtn.classList.remove('loading');
    submitBtn.removeAttribute('disabled');
    cartDrawer.open();
  });
};

/**
 * Get sections to render
 */
function getSectionsToRender() {
  return [
    {
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }
  ];
};

/**
 * Get section inner HTML
 */
function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
};